"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'CustomSelectUserModal',
  // 选择员工模态框组件，该组件一般用于通过弹框形式从组织架构中选择员工
  props: {
    // 获取部门树的接口方法
    getDeptTreeMethod: {
      type: Function,
      required: true
    },
    // 获取用户列表的接口方法
    getUserListMethod: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      default: '选择员工'
    },
    // 是否必须选择至少一个员工
    required: {
      type: Boolean,
      default: false
    },
    // 提示语
    desc: {
      type: String,
      default: undefined
    },
    // 自定义属性 - 默认选中员工id数组
    defaultSelectedUserIds: {
      type: Array,
      default: () => []
    },
    // 自定义属性 - 默认选中的员工数组
    defaultSelectedUsers: {
      type: Array,
      default: () => [] // [{userName:'',userId:'',jobNumber:''}]
    },
    columns: {
      type: Array,
      default: () => {
        return [{
          dataIndex: 'userName',
          title: '姓名',
          width: 120,
          scopedSlots: {
            customRender: 'userName'
          },
          searchProps: {
            dataIndex: 'name',
            width: 150
          }
        }, {
          dataIndex: 'jobNumber',
          title: '工号',
          width: 120,
          searchProps: {
            width: 150
          }
        }, {
          dataIndex: 'mobile',
          title: '手机号码',
          width: 120,
          scopedSlots: {
            customRender: 'mobile'
          }
        }, {
          dataIndex: 'title',
          title: '职位',
          width: 120
        }, {
          dataIndex: 'deptNames',
          title: '部门',
          width: 120
        }, {
          dataIndex: 'workStatus',
          title: '工作状态',
          width: 100,
          customRender: text => ['已离职', '在职'][text],
          customCell: record => {
            return {
              class: ['m-tips-color', 'm-type-success'][record.workStatus]
            };
          },
          searchProps: {
            defaultValue: '1',
            placeholder: '请选择',
            width: 100,
            valueType: 'select',
            valueEnum: {
              0: '已离职',
              1: '在职'
            }
          }
        }, {
          dataIndex: 'status',
          title: '账号状态',
          width: 100,
          customRender: text => ['禁用', '启用'][text],
          customCell: record => {
            return {
              class: ['m-tips-color', 'm-type-success'][record.status]
            };
          }
        }];
      }
    }
  },
  data() {
    return {
      visible: false,
      // ! 组织架构 Begin
      keyword: '',
      expandedKeys: [],
      autoExpandParent: true,
      treeData: [],
      replaceFields: {
        children: 'children',
        title: 'deptName',
        key: 'id'
      },
      deptId: undefined,
      // 部门ID（包括子部门员工）
      // ! 组织架构 End

      // ! 员工列表 Begin
      selectedUserIds: [],
      // 选择的员工id数组
      selectedUsers: [] // 选择的员工数组
      // ! 员工列表 End
    };
  },
  computed: {
    selectedUser() {
      return this.selectedUsers.map(item => item.userName).toString();
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.deptId = undefined;
          this.getDeptTree();
          if (this.defaultSelectedUserIds.length > 0) this.selectedUserIds = this.defaultSelectedUserIds;
          if (this.defaultSelectedUsers.length > 0) this.selectedUsers = this.defaultSelectedUsers;
        }
      },
      immediate: true
    }
  },
  created() {
    // 使用 Lodash 实现防抖
    this.debouncedSearch = _.debounce(this.handleSearch, 200);
  },
  unmounted() {
    // 移除组件时，取消定时器
    this.debouncedSearch.cancel();
  },
  methods: {
    // 提供给父组件通过 this.$refs.userSelectModal.open() 调用
    open() {
      this.visible = true;
    },
    // 提供给父组件通过 this.$refs.userSelectModal.close() 调用
    close() {
      this.visible = false;
    },
    handleCopy(text) {
      if (this.$m.copyText(text)) {
        this.$message.success('复制成功');
      }
    },
    handleOk() {
      if (this.selectedUserIds.length === 0 && this.required) {
        this.$message.warning('请选择需要添加的人员');
        return;
      }
      console.info('%c CustomSelectUserModal组件ok事件返回值', 'color: green;', {
        selectedUserIds: this.selectedUserIds,
        selectedUsers: this.selectedUsers
      });
      this.$emit('ok', {
        selectedUserIds: this.selectedUserIds,
        selectedUsers: this.selectedUsers
      });
      this.selectedUserIds = [];
      this.selectedUsers = [];
      this.visible = false;
    },
    // ! 组织架构 Begin
    async getDeptTree() {
      try {
        this.treeData = await this.getDeptTreeMethod();
        this.expandedKeys = [this.treeData[0].id];
      } catch (e) {}
    },
    handleSelectTree(selectedKeys, e) {
      this.deptId = selectedKeys[0] || undefined;
      this.reload();
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    // ! 组织架构 End

    // ! 员工列表 Begin
    // 对员工列表进行数据格式转换，统一使用 userId、userName
    transformDataSource(data) {
      data.forEach(item => {
        item.userId = item.userId || item.id;
        item.userName = item.userName || item.name;
        item.deptNames = item.deptNames || item.depts?.map(dept => dept.deptName);
      });
    },
    // 搜索员工列表
    handleSearch() {
      const {
        keyword,
        treeData,
        replaceFields
      } = this;
      if (!keyword) {
        this.expandedKeys = [treeData[0].id];
      } else {
        const list = this.$m.tree.toList(treeData, {
          pid: 'parentId',
          children: 'children'
        });
        const _list = list.filter(item => item[replaceFields.title].indexOf(keyword) > -1);
        const targetValues = _list.map(item => item[replaceFields.key]);
        let tempArr = [];
        targetValues.forEach(item => {
          const arr = this.$m.tree.findPathAll(treeData, node => node[replaceFields.key] === item, {
            pid: 'parentId',
            children: 'children'
          });
          const _values = arr[0].map(_item => _item[replaceFields.key]);
          tempArr = [...tempArr, ..._values];
        });
        this.expandedKeys = tempArr;
      }
    },
    handleRowSelectionChange({
      selectedRowKeys,
      selectedRows
    }) {
      this.selectedUserIds = selectedRowKeys;
      this.selectedUsers = selectedRows;
    },
    reload() {
      this.$nextTick(() => {
        this.$refs.basisTableLayout && this.$refs.basisTableLayout.reload();
      });
    }
    // ! 员工列表 End
  }
};